<template>
    <div class="card shadow-sm mb-3" @mouseover="getContacts">
        <div class="card-body">
            <label>Dirigeant</label>
            <b-select
                v-model="ownerContactId"
                size="sm"
                :class="reactiveClass"
                :options="contactOptions"
                @change="setOwnerContact"
            />
        </div>
    </div>
</template>

<script>
import TableFormHandler from '../../../../common/mixins/TableFormHandler.vue'

export default {
    name: 'OwnerContactSelect',

    mixins: [TableFormHandler],

    props: {
        companyId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            form: {
                client_id: null,
                client_contact_id: null,
                contact_type: null,
            },
            ownerContactId: null,
            contactOptions: [{ text: 'Non défini', value: null }],
            defaultContacts: [],
            contacts: [],
            company: {},
        }
    },

    async created() {
        this.align = 'left'
        this.border = true
        await this.getContacts()
        await this.getDefaultContacts()
        this.form.client_id = this.companyId
    },

    methods: {
        async getContacts() {
            try {
                const response = await this.$axios.get(
                    `/clientContacts/${this.companyId}`
                )
                this.contacts = response.data.data
                this.setContactOptions()
            } catch (error) {
                //
            }
        },
        setContactOptions() {
            this.contactOptions = [{ text: 'Non défini', value: null }]
            for (let i = 0; i < this.contacts.length; i++) {
                this.contactOptions.push({
                    value: this.contacts[i].client_contact_id,
                    text: `${this.contacts[i].firstname} ${this.contacts[i].surname}`,
                })
            }
        },

        async getDefaultContacts() {
            try {
                const response = await this.$axios.get(
                    `/defaultContacts/${this.companyId}`
                )
                this.defaultContacts = response.data.data
                this.setDefaultContactIds()
            } catch (error) {
                //
            }
        },

        setDefaultContactIds() {
            if (this.defaultContacts.length > 0) {
                const owner = this.defaultContacts.find(
                    (item) => item.contact_type === 'owner'
                )
                this.ownerContactId =
                    owner === null ? null : owner.client_contact_id
            }
        },

        async setOwnerContact() {
            this.form.contact_type = 'owner'
            this.form.client_contact_id = this.ownerContactId
            try {
                await this.$axios.post(`/defaultContacts`, this.form)
                this.handleSelectSuccess()
            } catch (error) {
                this.handleError()
            }
        },
    },
}
</script>

<style scoped></style>
